import axios from 'axios'

/**
 * 获取订单列表
 */
export const getOrderData = async (options) => {
  let url = `v1/trades/sim-renewal/orders?pageNo=${options.pageNo}&pageSize=${options.pageSize}&payChannelAppId=${options.payChannelAppId}`
  // 订单状态
  if (options.orderState) {
    url += `&orderState=${options.orderState}`
  }
  // 商户订单号。支持后模糊查询
  if (options.outTradeNo) {
    url += `&outTradeNo=${options.outTradeNo}`
  }
  // 买家名称
  if (options.projectName) {
    url += `&projectName=${options.projectName}`
  }
  // 时间区间：格式yyyy-mm-dd hh:ss:dd
  if (options.paymentStartDate && options.paymentEndDate) {
    url += `&paymentStartDate=${options.paymentStartDate}&paymentEndDate=${options.paymentEndDate}`
  }
  const { data } = await axios.get(url)
  return data
}

/**
 * 根据订单号获取流量充值设备列表
 */
export const getdeviceLiseById = async (option) => {
  const { data } = await axios.get(`v1/order/sim-recharge-list?orderId=${option}`)
  return data
}

/**
 * 根据订单id导出设备的excel列表
 */
export const getExcelById = async (option) => {
  await axios.get(`v1/trades/sim-renewal/export-items?orderId=${option}`, { responseType: 'arraybuffer' }).then(
    (res) => {
      const content = res.data
      const disposition = res.headers['content-disposition']
      const template = res.headers['content-disposition'].split('.')
      const suffix = '.' + template[template.length - 1]
      const filename = decodeURI(disposition.split('=')[1].split('_')[0])
      const blob = new Blob([content])
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename + suffix
      link.style.display = 'none'
      link.click()
    })
}

/**
 * 订单标记完成
 */
export const modifyMarkCompleted = async (orderId) => {
  const { data } = await axios.post(`v1/trades/sim-renewal/done?orderId=${orderId}`)
  return data
}

/**
 * 订单退款
 */
export const modifyRefund = async (orderId) => {
  const { data } = await axios.post(`v1/trades/sim-renewal/refund?orderId=${orderId}`)
  return data
}

/**
 * 获取订单下设备信息
 */
export const getDeviceByOrderId = async (options) => {
  const { data } = await axios.get(`v1/trades/sim-renewal/order-items?orderId=${options.orderId}&pageNo=${options.pageNo}&pageSize=${options.pageSize}`)
  return data
}

/**
 * 获取所有商品
 */
export const getAllCommodity = async (options) => {
  const { data } = await axios.get(`v1/commodity-sim-renewals?pageNo=${options.pageNo}&pageSize=${options.pageSize}`)
  return data
}

/**
 * 添加商品
 */
export const addCommodity = async (options) => {
  const { data } = await axios.post(`v1/commodity-sim-renewals`, options)
  return data
}

/**
 * 修改商品
 */
export const editCommodity = async (options) => {
  const { data } = await axios.put(`v1/commodity-sim-renewals/${options.id}`, options)
  return data
}

/**
 * 根据id删除商品
 */
export const deleteCommodity = async (id) => {
  const { data } = await axios.delete(`v1/commodity-sim-renewals/${id}`)
  return data
}

/**
 * 商品上架
 */
export const editStatusToEnable = async (id) => {
  const { data } = await axios.post(`v1/commodity-sim-renewals/${id}/enable`)
  return data
}

/**
 * 商品下架
 */
export const editStatusToDisable = async (id) => {
  const { data } = await axios.post(`v1/commodity-sim-renewals/${id}/disable`)
  return data
}
